export default class Store {
  constructor(data) {
    this.id = data?.id ?? null;
    this.category = data?.category ?? 'EVENT_ORGANIZER';
    this.name = data?.name ?? '';
    this.phonePrimary = data?.phone_primary ?? '';
    this.phoneSecondary = data?.phone_secondary ?? '';
    this.emailPrimary = data?.email_primary ?? '';
    this.emailSecondary = data?.email_secondary ?? '';
    this.postalCode = data?.postal_code ?? '';
    this.prefecture = data?.prefecture ?? '';
    this.city = data?.city ?? '';
    this.town = data?.town ?? '';
    this.building = data?.building ?? '';
    this.status = data?.status ?? 'ACTIVE';
    this.dataProviderId = data?.data_provider_id ?? null;
    this.createdAt = data?.created_at ?? null;
    this.updatedAt = data?.updated_at ?? null;
  }

  toJson() {
    return {
      name: this.name,
      phone_primary: this.phonePrimary,
      phone_secondary: this.phoneSecondary,
      email_primary: this.emailPrimary,
      email_secondary: this.emailSecondary,
      postal_code: this.postalCode,
      prefecture: this.prefecture,
      city: this.city,
      town: this.town,
      building: this.building
    };
  }
}
